import {
  Breadcrumb,
  ChatBubbleLeftEllipsisIcon,
  ChevronLeftIcon,
  CreditCardIcon,
  DevicePhoneMobileIcon,
  Link,
  PageHero,
  PuzzlePieceIcon,
} from "@";

const CATEGORIES = [
  {
    title: "بوابات الدفع",
    description: "اختر بوابة الدفع المستخدمة لاستقبال التبرعات.",
    href: "/settings-integrations/payments",
    icon: CreditCardIcon,
    providers: ["MyFatoorah", "Paymob", "Moyasar"],
    accent: "from-purple-100 to-purple-50 text-purple-900",
    dot: "bg-purple-600",
  },
  {
    title: "مزوّدو WhatsApp",
    description: "اربط حسابك بمنصة لإرسال رسائل WhatsApp.",
    href: "/settings-integrations/whatsapp",
    icon: ChatBubbleLeftEllipsisIcon,
    providers: ["Wati", "Autorply"],
    accent: "from-emerald-100 to-emerald-50 text-emerald-900",
    dot: "bg-emerald-600",
  },
  {
    title: "مزوّدو الرسائل القصيرة",
    description: "اختر مزوّد SMS الذي تستخدمه الحملات والإشعارات.",
    href: "/settings-integrations/sms",
    icon: DevicePhoneMobileIcon,
    providers: ["OurSMS"],
    accent: "from-sky-100 to-sky-50 text-sky-900",
    dot: "bg-sky-600",
  },
];

const Index = () => {
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "التكاملات", link: "" },
  ];

  return (
    <>
      <Breadcrumb links={links} />

      <main className="table-card relative pb-5">
        <PageHero
          eyebrow="الإعدادات / التكاملات"
          title="التكاملات الخارجية"
          icon={PuzzlePieceIcon}
          count={CATEGORIES.length}
        />

        <p className="mb-5 max-w-2xl px-1 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
          اختر مزوّدي الخدمات الذين يعمل بهم متجرك. لكل فئة مزوّد واحد فعّال في
          نفس الوقت — يمكنك تبديله متى شئت من صفحته المخصصة.
        </p>

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {CATEGORIES.map((cat) => {
            const Icon = cat.icon;
            return (
              <Link
                key={cat.href}
                to={cat.href}
                className="group relative flex flex-col gap-4 overflow-hidden rounded-2xl border border-gray-200 bg-white p-5 transition-all duration-200 hover:-translate-y-0.5 hover:border-purple-200 hover:shadow-md hover:shadow-purple-900/5 dark:border-gray-700 dark:bg-gray-800/60 dark:hover:border-purple-700/40"
              >
                {/* Header: icon chip + chevron */}
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ring-1 ring-gray-100 dark:ring-gray-700 ${cat.accent} dark:from-gray-900/60 dark:to-gray-900/40 dark:text-gray-200`}
                  >
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </span>

                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-50 text-gray-400 transition-all duration-200 group-hover:bg-purple-50 group-hover:text-purple-700 dark:bg-gray-700/60 dark:text-gray-400 dark:group-hover:bg-purple-900/40 dark:group-hover:text-purple-300">
                    <ChevronLeftIcon className="h-4 w-4" strokeWidth={2.5} />
                  </span>
                </div>

                {/* Title + description */}
                <div>
                  <h3 className="text-lg font-bold tracking-tight text-gray-900 dark:text-gray-100">
                    {cat.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
                    {cat.description}
                  </p>
                </div>

                {/* Provider chips */}
                <div className="mt-auto flex flex-wrap items-center gap-1.5 border-t border-gray-100 pt-3 dark:border-gray-700/60">
                  <span className="me-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-400 dark:text-gray-500">
                    المزوّدون
                  </span>
                  {cat.providers.map((p) => (
                    <span
                      key={p}
                      className="inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-2 py-0.5 text-[11px] font-semibold text-gray-700 ring-1 ring-gray-200 dark:bg-gray-900/40 dark:text-gray-300 dark:ring-gray-700"
                    >
                      <span
                        aria-hidden
                        className={`h-1.5 w-1.5 rounded-full ${cat.dot}`}
                      />
                      {p}
                    </span>
                  ))}
                </div>
              </Link>
            );
          })}
        </div>
      </main>
    </>
  );
};

export default Index;
